import React from 'react'
import { sizeForHumans } from '@utilities/sizeForHumans'

const FileMessage = (props) => {
  if (!props.message.string) return null
  const messageInfo = JSON.parse(props.message.string)

  return (
    <div className="text">
      <div className="value">
        <a target="_blank" rel="noopener noreferrer" href={props.message.fileUrl}>
          {messageInfo.fileName}
        </a>
        <span> ({sizeForHumans(messageInfo.fileSize)})</span>
      </div>
    </div>
  )
}

export default FileMessage
